import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export function calculateMonthsBetween(startDate: string, endDate: string): number {
  const [startYear, startMonth] = startDate.split('-').map(Number);

  let endYear: number, endMonth: number;
  if (endDate === 'Present') {
    const now = new Date();
    endYear = now.getFullYear();
    endMonth = now.getMonth() + 1;
  } else {
    [endYear, endMonth] = endDate.split('-').map(Number);
  }

  let months = (endYear - startYear) * 12 + (endMonth - startMonth);
  return months >= 0 ? months + 1 : 0; //Added +1 to include both start and end months, handling negative differences.

}

/**
 * Utility function to check if content is meaningful for conditional rendering
 * @param content - The content to check (string, string array, or null/undefined)
 * @returns true if the content has meaningful data, false otherwise
 */
export function hasContent(content: string | string[] | undefined | null): boolean {
  if (!content) return false;
  if (typeof content === 'string') {
    return content.trim().length > 0;
  }
  if (Array.isArray(content)) {
    return content.some(item => item && item.trim().length > 0);
  }
  return false;
}

/**
 * Certification Design System
 * Centralized colors and styling for certification features
 */
export const CERTIFICATION_DESIGN = {
  colors: {
    badge: 'text-yellow-500',
    progressBar: 'bg-yellow-500',
    progressBarClass: '[&>div]:bg-yellow-500',
  }
} as const;